import { Img } from 'globalStyles'
import React from 'react'
import { FooterItemDiv } from './style'

function FooterItem({ icon, text = 'phone' }) {
  return (
    <FooterItemDiv>
      <Img src={icon} width={24} height={24} alt={text} />
      <p className="text-contact font-medium text-sm font-montserrat">{text}</p>
    </FooterItemDiv>
  )
}

export default FooterItem
